<template>
  <validation-observer ref="simpleRules">
    <b-row>
      <b-col>
        <h5 class="mb-2">
          Harga dan Stok (Varian Default)
        </h5>
      </b-col>
      <!-- Harga -->
      <b-col cols="12">
        <b-form-group
          label-for="input-price"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.price.title"
              :description="labelForm.price.description"
              required
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="harga"
            rules="required"
          >
            <b-input-group prepend="Rp">
              <cleave
                id="input-price"
                v-model="form.originalPrice"
                class="form-control"
                :class="{'is-invalid' : errors.length > 0}"
                :raw="true"
                :options="options.number"
                :disabled="!form.can_edit_price"
              />
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Harga Diskon -->
      <b-col cols="12">
        <b-form-group
          label-for="input-old-price"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.discountPrice.title"
              :description="labelForm.discountPrice.description"
            />
          </template>
          <b-input-group prepend="Rp">
            <cleave
              id="input-old-price"
              v-model="form.discountedPrice"
              class="form-control"
              :class="{'is-invalid': form.discountedPrice && form.originalPrice && Number(form.discountedPrice) >= Number(form.originalPrice)}"
              :raw="true"
              :options="options.number"
              :disabled="!form.can_edit_price"
            />
          </b-input-group>
          <small
            v-if="form.discountedPrice && form.originalPrice && Number(form.discountedPrice) >= Number(form.originalPrice)"
            class="text-danger mt-25 d-block"
          >
            Harga tidak sesuai
          </small>
        </b-form-group>
      </b-col>
      <!-- Berat -->
      <b-col cols="12">
        <b-form-group
          label-for="input-start-age"
          label-cols-md="4"
          content-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.weight.title"
              :description="labelForm.weight.description"
              required
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="berat"
            rules="required"
          >
            <b-input-group append="gram">
              <cleave
                id="input-weight"
                v-model="form.weight"
                class="form-control"
                :class="{'is-invalid' : errors.length > 0}"
                :raw="true"
                :options="options.number"
              />
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- Stok -->
      <b-col cols="12">
        <b-form-group
          label-for="input-stock"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.stock.title"
              :description="labelForm.stock.description"
              required
            />
          </template>
          <validation-provider
            #default="{ errors }"
            name="stok"
            rules="required"
          >
            <cleave
              id="input-stock"
              v-model="form.stock"
              class="form-control"
              :class="{'is-invalid' : errors.length > 0}"
              :raw="true"
              :options="options.number"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <!-- SKU -->
      <b-col cols="12">
        <b-form-group
          label-for="input-sku"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.sku.title"
              :description="labelForm.sku.description"
            />
          </template>
          <b-form-input
            id="input-sku"
            v-model="form.sku_name"
          />
        </b-form-group>
      </b-col>
      <!-- Pre-Order -->
      <b-col cols="12">
        <b-form-group
          label-for="input-preorder"
          label-cols-md="4"
          label-class="pt-0"
        >
          <template #label>
            <FormLabel
              :title="labelForm.preorder_days.title"
              :description="labelForm.preorder_days.description"
            />
          </template>
          <b-form-select
            id="input-preorder"
            v-model="form.preorder_days"
            :options="preorderOptions"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import {
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BRow,
  BFormSelect,
} from 'bootstrap-vue'

import Cleave from 'vue-cleave-component'

// Quill Editor
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import { mapState, mapGetters, mapActions } from 'vuex'

import FormLabel from '@/layouts/components/custom/FormLabel.vue'

export default {
  name: 'ProductVariantForm',
  components: {
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BRow,
    ValidationProvider,
    ValidationObserver,
    Cleave,
    FormLabel,
    BFormSelect,
  },
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: '.',
          numeralPositiveOnly: true,
        },
      },
      required,
      preorderOptions: [
        { value: null, text: 'In-stock' },
        { value: 7, text: '7 Hari' },
        { value: 14, text: '14 Hari' },
        { value: 21, text: '21 Hari' },
        { value: 28, text: '28 Hari' },
      ],
    }
  },
  computed: {
    ...mapState('merchant', ['merchants']),
    ...mapState('products', ['labelForm']),
    ...mapGetters('category', ['categoryList']),
  },
  async mounted() {
    // await this.getCategoryList()
  },
  methods: {
    ...mapActions('merchant', ['getMerchantList']),
    ...mapActions('category', ['getCategoryList']),
    async validationForm() {
      const response = await this.$refs.simpleRules.validate()

      // Discount price must be less than original price
      if (this.form.discountedPrice && this.form.originalPrice && Number(this.form.discountedPrice) >= Number(this.form.originalPrice)) {
        return false
      }

      return response
    },
    async onSearchMerchant(text) {
      this.isSearchingMerchant = true
      await this.getMerchantList({ keyword: text })
      this.isSearchingMerchant = false
    },
  },
}
</script>
